import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "divide-y divide-gray-200" }
const _hoisted_4 = { class: "gap-6 mt-6 sm:grid sm:grid-cols-4" }
const _hoisted_5 = { class: "sm:col-span-4" }
const _hoisted_6 = { class: "flex justify-center px-6 pt-5 pb-6 mt-1 border-2 border-dashed rounded-md border-clay-500" }
const _hoisted_7 = {
  key: 0,
  class: "space-y-1 text-center"
}
const _hoisted_8 = { class: "max-w-2xl text-sm text-clay-800" }
const _hoisted_9 = {
  key: 1,
  class: "space-y-1 text-center"
}
const _hoisted_10 = { class: "bg-white" }
const _hoisted_11 = { class: "py-8 mx-auto sm:py-12" }
const _hoisted_12 = { class: "grid grid-cols-1 mt-6 gap-x-8 gap-y-8 sm:grid-cols-2 sm:gap-y-10 lg:grid-cols-4" }
const _hoisted_13 = {
  key: 1,
  class: "sm:col-span-4"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "text-sm font-medium text-clay-800"
}
const _hoisted_16 = {
  class: "border border-gray-200 divide-y divide-gray-200 rounded-md",
  role: "list"
}
const _hoisted_17 = {
  class: "z-40",
  "x-cloak": "",
  "x-data": "dropdown"
}
const _hoisted_18 = { class: "flex items-center justify-between py-3 pl-3 pr-4 text-sm" }
const _hoisted_19 = { class: "flex items-center flex-1 w-0" }
const _hoisted_20 = { class: "flex-1 w-0 ml-2 truncate" }
const _hoisted_21 = {
  key: 0,
  class: "ml-4 shrink-0"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 1,
  class: "ml-4 shrink-0"
}
const _hoisted_25 = {
  id: "resumeName",
  "aria-labelledby": "menu-button",
  "aria-orientation": "vertical",
  class: "flex items-center justify-between py-3 pl-3 pr-4 text-sm",
  role: "menu",
  tabindex: "-1",
  "x-show": "open"
}
const _hoisted_26 = { class: "" }
const _hoisted_27 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_28 = { class: "ml-4 shrink-0" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 2,
  class: "mt-4 text-sa-red-600"
}

import {onMounted, Ref, ref} from "vue";
import {client, validateFileSize, validateFileType} from '@/shared';
import {
    DeleteResume,
    GetResumes,
    GetResumesResponse,
    UpdateFriendlyNameForUploadedResume,
    UploadedResumeDTO,
    UploadResume
} from "@/dtos";
// @ts-ignore
import Uploadcare from 'uploadcare-vue/src/Uploadcare.vue';
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import {trackEvent} from '@/shared';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileResumeSettings',
  setup(__props) {

const responseStatus = ref(null);
const resumes: Ref<UploadedResumeDTO[]> = ref([]);

const updateSuccessful: Ref<Boolean> = ref(false);


const isFetching = ref(true);
onMounted(async () => {
    await getResumes();
});

const getResumes = async () => {
    await client.get<GetResumesResponse>(new GetResumes())
        .then(response => {
            resumes.value = response.resumes;
            isFetching.value = false;
        });
}

const fileValidators = [
    validateFileType('pdf'),
    validateFileSize(1024*1024*4) // 4mb
];


const isUploading = ref(false);
const onUploadSuccess = async (response: any) => {
    console.log(response);
    isUploading.value = true;
    await client.post<GetResumesResponse>(new UploadResume({
        fileUrl: response.cdnUrl,
        friendlyName: response.name
    }))
        .then(async (res) => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            resumes.value = res.resumes;

            trackEvent( 'profile_updated', {
                method: 'resume_uploaded'
            });
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

    isUploading.value = false;
}

const editResume = async (resume: UploadedResumeDTO) => {
    await client.post<GetResumesResponse>(new UpdateFriendlyNameForUploadedResume({
        id: resume.id,
        friendlyName: resume.friendlyName
    }))
        .then(async (res) => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            resumes.value = res.resumes;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
}

const resumeBeingDeleted = ref('');
const deleteResume = async (resume: UploadedResumeDTO) => {
    resumeBeingDeleted.value = resume.id;
    await client.delete<GetResumesResponse>(new DeleteResume({
        id: resume.id
    }))
        .then(async (res) => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            resumes.value = res.resumes;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    resumeBeingDeleted.value = '';
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", null, [
        _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "cover-photo"
                }, " Upload Resume ", -1)),
                _createElementVNode("div", _hoisted_6, [
                  (resumes.value?.length >= 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("p", _hoisted_8, "You currently have " + _toDisplayString(resumes.value.length) + " resumes. You can only upload upto 3 resumes.", 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(Uploadcare, {
                          imagesOnly: false,
                          "input-accept-types": "application/pdf",
                          validators: fileValidators,
                          publicKey: "c1ecae68d0087aa3986a",
                          tabs: "file url facebook gdrive dropbox instagram evernote flickr skydrive",
                          onSuccess: _cache[0] || (_cache[0] = (response) => onUploadSuccess(response))
                        }, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createElementVNode("svg", {
                              class: "w-12 h-12 mx-auto text-gray-400",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              viewBox: "0 0 24 24",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1),
                            _createElementVNode("div", { class: "flex text-sm text-gray-600" }, [
                              _createElementVNode("a", { class: "relative flex items-center justify-center px-8 py-2 text-sm font-medium text-white border border-transparent rounded-md bg-clay-800 hover:bg-clay-950" }, "Upload File")
                            ], -1),
                            _createElementVNode("p", { class: "text-xs text-clay-800" }, " PDF up to 2MB ", -1)
                          ])),
                          _: 1
                        })
                      ]))
                ])
              ])
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-4 text-sm text-clay-800" }, "* Be careful including personal information on your resume such as your phone number and email address. Your PDF resume will be available for viewing by users on the internet. Anyone can view your resume and contact you if you include an email address or phone number. StageAgent has no association with anyone who might contact you and is not responsible for your interactions outside of our website.", -1))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex items-center justify-between space-x-4" }, [
              _createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Resumes / CVs")
            ], -1)),
            _createElementVNode("div", _hoisted_12, [
              (isFetching.value)
                ? (_openBlock(), _createBlock(SkeletonCard, {
                    key: 0,
                    class: "mt-4 col-span-full",
                    "card-style": "long",
                    "num-of-cards": 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (resumes.value?.length < 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, " You haven't uploaded a PDF of your resume. Upload your resume to gain exposure to more opportunities! "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, " Uploads")),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resumes.value, (resume) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: resume.id,
                        class: "mt-1 text-sm text-gray-900"
                      }, [
                        _createElementVNode("ul", _hoisted_16, [
                          _createElementVNode("li", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                  "aria-hidden": "true",
                                  class: "w-5 h-5 text-gray-400 shrink-0",
                                  fill: "currentColor",
                                  viewBox: "0 0 20 20",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }, [
                                  _createElementVNode("path", {
                                    "clip-rule": "evenodd",
                                    d: "M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z",
                                    "fill-rule": "evenodd"
                                  })
                                ], -1)),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(resume.friendlyName), 1)
                              ]),
                              (resumeBeingDeleted.value !== resume.id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createElementVNode("button", {
                                      class: "inline-block pl-3 font-medium text-powder-600 hover:text-powder-500",
                                      onClick: _withModifiers(($event: any) => (deleteResume(resume)), ["prevent"])
                                    }, " Delete ", 8, _hoisted_22),
                                    _createElementVNode("a", {
                                      href: resume.url,
                                      class: "inline-block pl-3 font-medium text-powder-600 hover:text-powder-500",
                                      target: "_blank",
                                      alt: "download resume",
                                      title: "download resume"
                                    }, _cache[5] || (_cache[5] = [
                                      _createElementVNode("svg", {
                                        class: "w-5 h-5",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        viewBox: "0 0 24 24",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        })
                                      ], -1)
                                    ]), 8, _hoisted_23),
                                    _cache[6] || (_cache[6] = _createElementVNode("button", {
                                      "aria-controls": "resumeName",
                                      "aria-expanded": "true",
                                      class: "inline-block pl-3 font-medium text-powder-600 hover:text-powder-500",
                                      type: "button",
                                      "x-on:click": "toggle",
                                      alt: "Edit",
                                      title: "Edit"
                                    }, [
                                      _createElementVNode("svg", {
                                        class: "w-5 h-5",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "1.5",
                                        viewBox: "0 0 24 24",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }, [
                                        _createElementVNode("path", {
                                          d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        })
                                      ])
                                    ], -1))
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[7] || (_cache[7] = [
                                    _createElementVNode("p", { class: "text-sa-red-600" }, "Deleting...please wait.", -1)
                                  ])))
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _cache[8] || (_cache[8] = _createElementVNode("label", {
                                  class: "justify-center inline-block px-3 font-medium text-gray-700 ext-sm algin-middle",
                                  for: ""
                                }, "Resume Title", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((resume.friendlyName) = $event),
                                  placeholder: resume.friendlyName,
                                  class: "inline-block px-3 py-2 mt-1 border rounded-md shadow-sm border-clay-500 focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                                  type: "text"
                                }, null, 8, _hoisted_27), [
                                  [_vModelText, resume.friendlyName]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("button", {
                                  class: "pl-3 font-medium text-powder-600 hover:text-powder-500",
                                  onClick: _withModifiers(($event: any) => (editResume(resume)), ["prevent"])
                                }, "Save ", 8, _hoisted_29)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128)),
                    (isUploading.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_30, "Uploading...please wait."))
                      : _createCommentVNode("", true)
                  ]))
            ])
          ])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mt-6" }, [
          _createElementVNode("div", { class: "p-6 text-center rounded-lg bg-powder-50" }, [
            _createElementVNode("p", null, [
              _createTextVNode("Need help properly formatting your resume? "),
              _createElementVNode("a", {
                href: "/pages/templates",
                class: "underline hover:font-semibold"
              }, "Download a Template")
            ])
          ])
        ], -1))
      ])
    ]),
    _createVNode(NotificationSuccess, {
      show: updateSuccessful.value,
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})